module.exports = __webpack_public_path__ + "img/AFRICA_NUTS.68b11067.png";